import FileIcon from "assets/icon/file";
import MoneyIcon from "assets/icon/Money";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

export default () => {
  function getActive(path: string, pathname: string) {
    return path ? !!matchPath({ path: path, end: false }, pathname) : false;
  }
  const customer = useSelector((state: any) => state.customer);
  const isPaymentModuleEnabled = customer.customer.isPaymentModuleEnabled;

  const customerId = localStorage.getItem("customerId");
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const navConfig = [
    {
      show: true,
      items: [
        {
          title: t("Documents"),
          path: `/${customerId}/documents`,
          icon: (
            <FileIcon
              color={
                getActive("/:id/documents", pathname) ? "#ffcc00" : "#657482"
              }
            />
          ),
        },
        {
          title: t("payments"),
          path: `/payments`,
          role: true,
          icon: (
            <MoneyIcon
              color={getActive("/payments", pathname) ? "#55C329" : "#657482"}
            />
          ),
          children: [
            {
              title: "payment_gateways",
              role: true,
              path: `/${customerId}/payments/paymentgateways`,
              color: getActive("/payments", pathname) ? "#55C329" : "#657482",
              locked: !isPaymentModuleEnabled,
            },
            {
              title: "invoice_payments",
              role: true,
              path: `/${customerId}/payments/invoicepayments`,
              color: getActive("/payments", pathname) ? "#55C329" : "#657482",
              locked: !isPaymentModuleEnabled,
            },
          ],
        },
      ],
    },
  ];

  return { navConfig };
};
